import create from 'zustand';

interface Store {
    darkModeOn: boolean;
    setDarkModeOn: (darkModeOn: boolean) => void; 
}

const useStore = create<Store>((set, get) => ({
    darkModeOn: false,
    setDarkModeOn: (darkModeOn) => set({ darkModeOn })
}))

export default useStore